module.exports = [{
      plugin: require('/tmp/553eb535/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/553eb535/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
